import { ThemeOptions } from '@mui/material';

import { charts } from './charts';
import { common } from './common';
import { dataDisplay } from './dataDisplay';
import { datePickers } from './datePickers';
import { feedback } from './feedback';
import { inputs } from './inputs';
import { navigation } from './navigation';
import { surfaces } from './surfaces';
import { utils } from './utils';

export type {} from './charts';
export type {} from './common';
export type {} from './dataDisplay';
export type {} from './datePickers';
export type {} from './feedback';
export type {} from './inputs';
export type {} from './navigation';
export type {} from './surfaces';
export type {} from './utils';

export const components: ThemeOptions['components'] = {
  ...common,
  ...dataDisplay,
  ...feedback,
  ...inputs,
  ...navigation,
  ...surfaces,
  ...utils,
  ...datePickers,
  ...charts
};
